"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNetworkFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const objects_1 = require("../../type-checking/objects");
const typing_1 = require("../../type-checking/typing");
const primitives_1 = require("../../type-checking/primitives");
class SocialNetworkFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                facebook_username: (0, typing_1.Optional)(primitives_1.isStringValue),
                linkedin_username: (0, typing_1.Optional)(primitives_1.isStringValue),
                instagram_username: (0, typing_1.Optional)(primitives_1.isStringValue),
                twitter_username: (0, typing_1.Optional)(primitives_1.isStringValue),
                sys_root: (0, typing_1.Optional)(primitives_1.isStringValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getSocialNetworkFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                fb: (0, typing_1.Optional)(primitives_1.isStringValue),
                li: (0, typing_1.Optional)(primitives_1.isStringValue),
                ig: (0, typing_1.Optional)(primitives_1.isStringValue),
                tw: (0, typing_1.Optional)(primitives_1.isStringValue),
            });
        };
        this.getValueFromOptimized = (fieldValue) => {
            var _a, _b, _c, _d;
            return {
                facebook_username: (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.fb) !== null && _a !== void 0 ? _a : "",
                linkedin_username: (_b = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.li) !== null && _b !== void 0 ? _b : "",
                instagram_username: (_c = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.ig) !== null && _c !== void 0 ? _c : "",
                twitter_username: (_d = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.tw) !== null && _d !== void 0 ? _d : "",
                sys_root: (0, get_value_1.generateSysRoot)(fieldValue),
            };
        };
    }
}
exports.SocialNetworkFieldValueGetter = SocialNetworkFieldValueGetter;
